import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './PetsyRefPopup.scss';
import { IPetsyRefPopupProps } from './PetsyRefPopup.types';

export default function PetsyRefPopup(props: IPetsyRefPopupProps) {
  const [renderKey, setRenderKey] = React.useState(0);

  function modalClose() {
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  function submit(link: string) {
    if (link) {
      window.open(link, '_blank');
    }
    // modalClose();
  }

  return (
    <>
      <Modal
        className='flc_petsy-ref-popup'
        show={props.show}
        onHide={modalClose}
        backdrop='static'
        keyboard={false}
        fullscreen='sm-down'
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='text-center' ref={optionRef}>
          <div className='ref-row'>
            <div className='ref-image'>
              <img src='/images/modal-ref-image.png' />
            </div>
          </div>

          <div className='ref-row mt-3'>
            <h4>How can we help you today?</h4>
          </div>
          <div className='ref-row mt-3'>
            <Button
              key={renderKey}
              disabled={false}
              className={'flc_purple-button btn'}
              onClick={() =>
                submit(
                  'https://petsy.com.au/do-i-need-pet-insurance-plus-why-costco-chose-petsy-as-their-exclusive-pet-insurance-provider/'
                )
              }
            >
              Do I need pet insurance?
            </Button>
          </div>
          <div className='ref-row mt-4'>
            <Button
              key={renderKey}
              disabled={false}
              className={'flc_purple-button btn'}
              onClick={() =>
                submit(
                  'https://calendly.com/petsythepetpeople/explain-help-me-compare-pet-insurance-3-15min-clone'
                )
              }
            >
              Book a time to explain and compare pet insurance policies
            </Button>
          </div>

          <div className='ref-row mt-4'>
            <Button
              key={renderKey}
              disabled={false}
              className={'flc_purple-button btn primary'}
              onClick={modalClose}
            >
              I’d like to get a quote for my pet/s
            </Button>
          </div>
          <div className='ref-row mt-4 mb-2'>
            <div className='ref-image award'>
              <img src='/images/modal-ref-image-award.png' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='md-footer-text'>
            Award-winning pet insurance for Australia’s pets
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
